export default "__VITE_ASSET__DAcq2ojE__"